import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useTier } from '../../context/TierContext';

// Audiences that should see the Pro marker: trial + grandfather users, who have access now
// but need the signal to understand what's Pro-gated. Paying subscribers don't need it;
// Free users already see ProLock blurs + upgrade triggers.
const shouldShow = (subscriptionStatus) =>
  subscriptionStatus === 'trial_active' ||
  subscriptionStatus === 'trial_carded' ||
  subscriptionStatus === 'grandfather_active';

/**
 * ProBadge — small dark-navy "Pro" chip used to mark Pro-gated sections.
 * Matches the HeaderCTA superscript style. Only renders for trial + grandfather users.
 * Override the visibility gate with `force={true}` for contexts that need it always (e.g. locked blurs).
 */
const ProBadge = ({ force = false, style, label = 'Pro' }) => {
  const { subscriptionStatus } = useTier();
  if (!force && !shouldShow(subscriptionStatus)) return null;

  return (
    <View style={[styles.badge, style]}>
      <Text style={styles.text}>{String(label).toUpperCase()}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  badge: {
    backgroundColor: 'rgba(5, 86, 247, 1)',
    borderRadius: 10,
    paddingHorizontal: 7,
    paddingVertical: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3,
    elevation: 3,
  },
  text: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 10,
    lineHeight: 14,
    letterSpacing: 0.3,
    color: '#FFFFFF',
  },
});

export default ProBadge;
